module.exports = __webpack_public_path__ + "img/dokoma-icon.d9dd19f4.svg";